import { FilterCategoryResponse, FilterValueResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { FilterCategory, FrontendFilterType } from '../../types/filters.type';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class GetAllFilters extends BaseAdapter<FilterCategoryResponse[]> implements AdapterInterface {
  rawResponse: FilterCategoryResponse[];

  async adaptResponse(): Promise<FilterCategory[]> {
    await this.fetchApiResponse('/api/all-filters', HTTPMethod.Get);
    return this.displayResponse();
  }

  displayResponse(): FilterCategory[] {
    return this.rawResponse.map((category: FilterCategoryResponse) => (
      {
        id: category.category_name,
        displayName: category.display_name,
        subcategories: category.subcategories.map((subcategory) => ({
          id: subcategory.subcategory_name,
          displayName: subcategory.display_name,
          description: subcategory.description,
          filters: subcategory.filters.map((filter) => ({
            id: filter.filter_name,
            displayName: filter.display_name,
            placeholder: filter.placeholder,
            description: filter.description,
            type: filter.type as FrontendFilterType,
            hasAllOption: filter.has_all_option,
            filterValues: filter.filter_values.map((filterValue: FilterValueResponse) => ({
              id: filterValue.name,
              displayName: filterValue.display_name,
            })),
            featureFlag: filter.feature_flag,
          })),
        })),
      }
    ));
  }
}
